import { Group } from '@/components/_common';
import { useBoschReport } from '@/core/domain/workorder/Bosch/Bosch.hooks';
import { useDisclosure, useReportGenerate } from '@/hooks';
import { Dropdown, Menu, Button, message } from 'antd';
import { Eye, Download, Share2, ChevronDown } from 'react-feather';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import useCopyToClipboard from '@/hooks/useCopyToClipboard';
import ComplementWhatsappModal from '../../WorkOrderFooter/ComplementWhatsappButton/ComplementWhatsappModal';
import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';

export default function BoschCoReReport() {
  const {
    workorder: { data: workorder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const [wppOpened, wppAction] = useDisclosure();

  const report = useReportGenerate();

  const boschReport = useBoschReport();

  const copyToClipboard = useCopyToClipboard();

  const downloadOrOpenReport = async (type: 'download' | 'open') => {
    try {
      if (!complement?.id) return;

      let result = boschReport.data;

      if (!result) {
        result = await boschReport.mutateAsync(complement.id);
      }

      const fileName = `Relatório-Bosch-CoRe-${
        complement.complementIdentifier
      }-${Number(new Date())}.pdf`;

      const fileType = 'application/pdf';

      switch (type) {
        case 'download':
          report.downloadFile({
            fileName,
            result,
            type: fileType,
          });
          break;

        case 'open':
          report.openFile({ fileName, result, fileType });
          break;
      }
    } catch {}
  };

  const copyLink = () => {
    if (!complement?.workOrderGuid)
      return message.error(
        'Não foi encontrado o código público do complemento (GUID)',
      );

    wppAction.open();

    const urlToShare = `${process.env.REACT_APP_API_URL}/workorder/v1/Bosch/${complement?.workOrderGuid}/bosch-report-by-guid`;

    copyToClipboard.copyToClipboard(
      urlToShare,
      'Link copiado com sucesso!',
      'Erro ao copiar o link.',
    );
  };

  return (
    <>
      {boschReport.isLoading && (
        <ModalLoadingOverlay
          messages={['Gerando arquivo do relatório do diagnóstico...']}
        />
      )}

      <Dropdown
        overlay={
          <Menu
            items={[
              {
                label: (
                  <Group gap={10}>
                    <Eye size={14} />
                    <span>Visualizar relatório</span>
                  </Group>
                ),
                key: 'view',
                onClick: () => downloadOrOpenReport('open'),
              },
              {
                label: (
                  <Group gap={10}>
                    <Download size={14} />
                    <span>Baixar relatório</span>
                  </Group>
                ),
                key: 'download',
                onClick: () => downloadOrOpenReport('download'),
              },
              {
                label: (
                  <Group gap={10}>
                    <Share2 size={14} />
                    <span>Copiar e compartilhar link</span>
                  </Group>
                ),
                key: 'share',
                onClick: () => copyLink(),
              },
            ]}
          />
        }
        trigger={['click']}
      >
        <Button type="primary" className="btn-bosch">
          <Group gap={10}>
            <span>Relatório Bosch CoRe</span>
            <ChevronDown style={{ margin: 0 }} size={14} />
          </Group>
        </Button>
      </Dropdown>

      <ComplementWhatsappModal
        customerId={workorder?.customer?.id}
        open={wppOpened}
        onCancel={wppAction.close}
      />
    </>
  );
}
